import { BaseModel } from "./BaseModel";

export class Logtype extends BaseModel {
  schema = "/logtype";
  constructor(params) {
    return super(params, "/logtype");
  }
}
